// src/services/product.service.js
import api from './api';

const productService = {
  // Get all products with pagination and search
  getAllProducts: async (page = 1, limit = 10, search = '', companyId = null) => {
    try {
      const params = { page, limit };
      if (search) {
        params.search = search;
      }
      if (companyId) {
        params.companyId = companyId;
      }
      const response = await api.get('/products', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  },

  // Get product by ID
  getProductById: async (id) => {
    try {
      const response = await api.get(`/products/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching product:', error);
      throw error;
    }
  },

  // Create new product
  createProduct: async (productData) => {
    try {
      const response = await api.post('/products', productData);
      return response.data;
    } catch (error) {
      console.error('Error creating product:', error);
      throw error;
    }
  },

  // Update product
  updateProduct: async (id, productData) => {
    try {
      const response = await api.post(`/products/${id}`, productData);
      return response.data;
    } catch (error) {
      console.error('Error updating product:', error);
      throw error;
    }
  },

  // Delete product
  deleteProduct: async (id) => {
    try {
      const response = await api.delete(`/products/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting product:', error);
      throw error;
    }
  },

  // Get product count
  getProductCount: async (companyId = null) => {
    try {
      const params = companyId ? { companyId } : {};
      const response = await api.get('/products/count', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching product count:', error);
      throw error;
    }
  },
};

export default productService;